import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CatalogsModel } from '../../shared';
import { StoreService } from '../../core/store.service';
import { Observable } from 'rxjs';
import { EndWithSlash } from 'projects/lib-components/src/public_api';


@Injectable()
export class AdminCatalogsService {

  constructor(
    protected http: HttpClient,
    protected store: StoreService
  ) { }

  getCatalogs(): Observable<CatalogsModel> {
    return this.http.get<CatalogsModel>(`${EndWithSlash(this.store.AppParams.apiUrl)}api/catalogue/V2/CATALOGSADMIN/0`);
  }

  uploadFiles(pMode: string , pFile: File, pIdent: string): Observable<any> {
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer'
    };

    const formData: FormData = new FormData();
    formData.append('file', pFile, pFile.name);
    formData.append('mode', pMode);
    formData.append('ident', pIdent);
    formData.append('token', this.store.AppParams.token);
    return this.http.post(`${EndWithSlash(this.store.AppParams.apiUrl)}api/extraUpload`, formData, config);
  }

  convertFiles(model: CatalogsModel): Observable<CatalogsModel> {
    return this.http.post<CatalogsModel>(`${EndWithSlash(this.store.AppParams.apiUrl)}api/convert/`, model);
  }

}
